/**
 * 객체 설정 > 애플리케이션 객체 Store
 * @since 2018-06-21
 * @author kdydesign.kim
 */
import {ObjectSecProfileApiPrefix as objApiPrefix} from 'utils'
import {i18n} from '~/plugins/i18n'

import {isPreDefineWithApp} from 'objectSettingsUtils'

// 애플리케이션 객체
const initAppData = () => {
  return {
    app_obj_name: void 0,
    app_obj_desc: void 0,
    app_cate_id: 100,
    app_risk_id: 1,
    app_cntry_id: 410,
    app_tech: [],
    app_char: [],
    app_tag: [],
    app_obj_use_yn: 0,
    app_obj_tcp_tm_out: 30,
    app_obj_udp_tm_out: 30,
    app_signtr: [],
    app_obj_type: 0
  }
}

// 애플리케이션 객체 - 시스템 정의 객체
const initAppViewData = () => {
  return {
    app_obj_name: void 0,
    app_obj_desc: void 0,
    app_obj_comp_url: void 0,
    app_obj_srv_url: void 0,
    app_obj_prog: void 0,
    app_obj_port: void 0,
    app_obj_os: void 0,
    app_cate: {
      app_cate_uname: void 0
    },
    app_risk: {
      app_risk_id: 1,
      app_risk_uname: void 0
    },
    app_cntry: {
      app_cntry_code: '',
      app_cntry_uname: void 0
    },
    app_tech: [],
    app_char: [],
    app_tag: []
  }
}
// 시그니처 옵션
const initAppSignatureOptData = () => {
  return {
    app_signtr_opt_type: 1,
    app_signtr_opt_relative_opt_type: 1,
    app_signtr_opt_ptrn: void 0,
    app_signtr_opt_nocase_use_yn: 0,
    app_signtr_opt_pcre_use_yn: 0,
    app_signtr_opt_offset: void 0,
    app_signtr_opt_depth: void 0,
    app_signtr_opt_distance: void 0,
    app_signtr_opt_within: void 0,
    app_signtr_id: null
  }
}
// 시그니처 설정
const initAppSignatureData = () => {
  return {
    app_signtr_desc: void 0,
    app_signtr_prtc_type: 6,
    app_signtr_src_port: void 0,
    app_signtr_dst_port: void 0,
    app_signtr_opt: [
      initAppSignatureOptData()
    ]
  }
}
// </editor-fold>

export const state = () => ({
  defaultAppVersion: '',
  appData: initAppData(),
  appViewData: initAppViewData(),
  appSignatureData: initAppSignatureData(),
  appObjectDataList: [],
  selectedData: void 0,
  selectedSignatureData: void 0,
  copyData: void 0,
  appFilter: { // 애플리케이션 전용 필터
    appCategory: [],
    appTech: [],
    appChar: [],
    appFilterChar: [],
    appTag: [],
    appCountry: [],
    appRisk: []
  },
  appSearchFilter: { // 애플리케이션 그룹 상세 검색 전용 필터
    appSearchCategory: [],
    appSearchTech: [],
    appSearchChar: [],
    appSearchTag: [],
    appSearchCountry: [],
    appSearchRisk: []
  },
  countryCode: {}
})

export const mutations = {
  // 시그니처 옵션 추가
  addSignatureOptSet (state) {
    state.appSignatureData.app_signtr_opt.push(initAppSignatureOptData())
  },

  // 시그니처 옵션 삭제
  deleteSignatureOptSet (state, index) {
    state.appSignatureData.app_signtr_opt.splice(index, 1)
  },

  // 시그니처 설정 추가
  saveSignatureData (state) {
    state.appData.app_signtr.push(state.appSignatureData)
    state.selectedSignatureData = void 0
  },

  // 시그니처 설정 삭제
  // TAMS (multi 삭제 지원)
  deleteSignatureData (state) {
    // TAMS
    if (!_.isEmpty(state.selectedSignatureData)) {
      const appSignatureDataList = _.cloneDeep(state.appData.app_signtr)
      let filteredDataList = []
      if (_.get(state.selectedSignatureData, ['length'], 0) > 0) {
        const selectSignatureIds = _.map(state.selectedSignatureData, 'index')
        filteredDataList = _.filter(appSignatureDataList, row => {
          return selectSignatureIds.indexOf(row.index) === -1
        })
        state.appData.app_signtr = filteredDataList
      } else {
        const itemIndex = _.findIndex(appSignatureDataList, state.selectedSignatureData)
        appSignatureDataList.splice(itemIndex, 1)
        state.appData.app_signtr = appSignatureDataList
      }
    }
    state.selectedSignatureData = void 0
  },

  // 시그니처 설정 수정
  updateSignatureData (state) {
    const signatureData = state.appSignatureData
    state.appData.app_signtr = _.map(state.appData.app_signtr, (o) => {
      if (o.app_signtr_id === state.selectedSignatureData[0].app_signtr_id) o = signatureData
      return o
    })
    state.selectedSignatureData = void 0
  },
  // 시그니처 설정 조회
  getSignatureData (state) {
    state.appSignatureData = _.cloneDeep(state.selectedSignatureData[0])
  },
  // 시그니처 옵션 초기화
  resetSignatureOptData (state) {
    state.appSignatureData = initAppSignatureData()
  },
  // 시그니처 옵션 선택 변경
  changeSignatureOptions (state) {
    _.map(state.appSignatureData.app_signtr_opt, (o) => {
      o.app_signtr_opt_type = 1
      o.app_signtr_opt_relative_opt_type = 1
    })
  },
  // 시그니처 선택
  selectSignatureData (state, data) {
    state.selectedSignatureData = data
  },
  // 시그니처 선택 초기화
  resetSelectedData (state) {
    state.selectedSignatureData = void 0
  },
  // 시그니처 옵션 설정 변경
  changeRelativeOptType (state, {data, index}) {
    state.appSignatureData.app_signtr_opt[index].app_signtr_opt_relative_opt_type = data
  },
  // 시그니처 옵션 설정 초기화
  resetSignatureOptions (state, {data, index}) {
    const appSigntrOpt = state.appSignatureData.app_signtr_opt[index]
    if (data === 0) {
      appSigntrOpt.app_signtr_opt_offset = void 0
      appSigntrOpt.app_signtr_opt_depth = void 0
      appSigntrOpt.app_signtr_opt_distance = void 0
      appSigntrOpt.app_signtr_opt_within = void 0
    } else if (data === 1) {
      appSigntrOpt.app_signtr_opt_distance = void 0
      appSigntrOpt.app_signtr_opt_within = void 0
    } else {
      appSigntrOpt.app_signtr_opt_offset = void 0
      appSigntrOpt.app_signtr_opt_depth = void 0
    }
  },
  // 애플리케이션 객체 필터 조회
  setAppFilterData (state, data) {
    const appCategroy = _.map(data.filter_app_cate, (o) => {
      return { label: o.app_cate_uname, value: o.app_cate_id }
    })
    const appTech = _.map(data.filter_app_tech, (o) => {
      return { label: o.app_tech_uname, value: o.app_tech_id }
    })
    const appTag = _.map(data.filter_app_tag, (o) => {
      return { label: o.app_tag_uname, value: o.app_tag_id }
    })
    const appCountry = _.map(data.filter_app_cntry, (o) => {
      return { label: o.app_cntry_uname, value: o.app_cntry_id }
    })
    const appRisk = _.map(data.filter_app_risk, (o) => {
      return { label: o.app_risk_uname, value: o.app_risk_id }
    })
    const getAppChar = () => {
      let incCol = 0
      let colLen = 4
      const rowLen = Number(data.filter_app_char.length / 4)
      const tempData = []
      for (let j = 0; j < rowLen; j++) {
        const row = []
        for (let i = incCol; i < colLen; i++) {
          row.push({ label: data.filter_app_char[i].app_char_uname, value: data.filter_app_char[i].app_char_id })
        }
        tempData.push(row)
        incCol += 4
        colLen += 4
      }
      if (tempData.length > 0) {
        return tempData
      } else {
        return [ [ { label: '', value: void 0 } ] ]
      }
    }
    state.appFilter.appCategory = Object.freeze(appCategroy)
    state.appFilter.appTech = Object.freeze(appTech)
    state.appFilter.appTag = Object.freeze(appTag)
    state.appFilter.appCountry = Object.freeze(appCountry)
    state.appFilter.appRisk = Object.freeze(appRisk)
    state.appFilter.appChar = Object.freeze(getAppChar())
  },
  // 애플리케이션 객체 필터 조건 조회
  getAppSearchFilterData (state, data) {
    // 전체 총 개수
    const sumCnt = (mergeData, key) => {
      return _.map(mergeData, (o) => {
        if (o[`app_${key}_id`] === -1) {
          o = _.assign(o, {[`app_${key}_cnt`]: _.sum(_.map(data[`filter_app_${key}`], `app_${key}_cnt`))})
        } else {
          o = _.assign(o, {use: 0})
        }
        return o
      })
    }
    const
      appSearchCategory = _.concat(state.appSearchFilter.appSearchCategory, data.filter_app_cate),
      appSearchTech = _.concat(state.appSearchFilter.appSearchTech, data.filter_app_tech),
      appSearchChar = _.concat(state.appSearchFilter.appSearchChar, data.filter_app_char),
      appSearchTag = _.concat(state.appSearchFilter.appSearchTag, data.filter_app_tag),
      appSearchCountry = _.concat(state.appSearchFilter.appSearchCountry, data.filter_app_cntry),
      appSearchRisk = _.concat(state.appSearchFilter.appSearchRisk, data.filter_app_risk)
    state.appSearchFilter.appSearchCategory = Object.freeze(sumCnt(appSearchCategory, 'cate'))
    state.appSearchFilter.appSearchTech = Object.freeze(sumCnt(appSearchTech, 'tech'))
    state.appSearchFilter.appSearchChar = Object.freeze(sumCnt(appSearchChar, 'char'))
    state.appSearchFilter.appSearchTag = Object.freeze(sumCnt(appSearchTag, 'tag'))
    state.appSearchFilter.appSearchCountry = Object.freeze(sumCnt(appSearchCountry, 'cntry'))
    state.appSearchFilter.appSearchRisk = Object.freeze(sumCnt(appSearchRisk, 'risk'))
    data = Object.freeze(data)
  },

  // 애플리케이션 객체 필터 데이터 업데이트(cnt)
  updateAppSearchFilterData (state, data) {
    const appSearchCategory = _.map(state.appSearchFilter.appSearchCategory, (o) => {
      if (o.app_cate_id === -1) {
        return _.assign(o, {app_cate_cnt: _.sum(_.map(data.filter_app_cate, 'app_cate_cnt'))})
      } else {
        return _.assign(o, {
          app_cate_cnt: _.find(data.filter_app_cate, {app_cate_id: o.app_cate_id}).app_cate_cnt
        })
      }
    })
    const appSearchTech = _.map(state.appSearchFilter.appSearchTech, (o) => {
      if (o.app_tech_id === -1) {
        return _.assign(o, {app_tech_cnt: _.sum(_.map(data.filter_app_tech, 'app_tech_cnt'))})
      } else {
        return _.assign(o, {
          app_tech_cnt: _.find(data.filter_app_tech, {app_tech_id: o.app_tech_id}).app_tech_cnt
        })
      }
    })
    const appSearchChar = _.map(state.appSearchFilter.appSearchChar, (o) => {
      if (o.app_char_id === -1) {
        return _.assign(o, {app_char_cnt: _.sum(_.map(data.filter_app_char, 'app_char_cnt'))})
      } else {
        return _.assign(o, {
          app_char_cnt: _.find(data.filter_app_char, {app_char_id: o.app_char_id}).app_char_cnt
        })
      }
    })
    const appSearchTag = _.map(state.appSearchFilter.appSearchTag, (o) => {
      if (o.app_tag_id === -1) {
        return _.assign(o, {app_tag_cnt: _.sum(_.map(data.filter_app_tag, 'app_tag_cnt'))})
      } else {
        return _.assign(o, {
          app_tag_cnt: _.find(data.filter_app_tag, {app_tag_id: o.app_tag_id}).app_tag_cnt
        })
      }
    })
    const appSearchCountry = _.map(state.appSearchFilter.appSearchCountry, (o) => {
      if (o.app_cntry_id === -1) {
        return _.assign(o, {app_cntry_cnt: _.sum(_.map(data.filter_app_cntry, 'app_cntry_cnt'))})
      } else {
        return _.assign(o, {
          app_cntry_cnt: _.find(data.filter_app_cntry, {app_cntry_id: o.app_cntry_id}).app_cntry_cnt
        })
      }
    })
    const appSearchRisk = _.map(state.appSearchFilter.appSearchRisk, (o) => {
      if (o.app_risk_id === -1) {
        return _.assign(o, {app_risk_cnt: _.sum(_.map(data.filter_app_risk, 'app_risk_cnt'))})
      } else {
        return _.assign(o, {
          app_risk_cnt: _.find(data.filter_app_risk, {app_risk_id: o.app_risk_id}).app_risk_cnt
        })
      }
    })
    state.appSearchFilter.appSearchCategory = Object.freeze(appSearchCategory)
    state.appSearchFilter.appSearchTech = Object.freeze(appSearchTech)
    state.appSearchFilter.appSearchChar = Object.freeze(appSearchChar)
    state.appSearchFilter.appSearchTag = Object.freeze(appSearchTag)
    state.appSearchFilter.appSearchCountry = Object.freeze(appSearchCountry)
    state.appSearchFilter.appSearchRisk = Object.freeze(appSearchRisk)
    data = Object.freeze(data)
  },
  // 애플리케이션 객체 필터 조건 초기화
  resetAppSearchFilterData (state) {
    // TAMS
    state.appSearchFilter.appSearchCategory = Object.freeze([{app_cate_id: -1, app_cate_uname: i18n.t('cmn.all'), app_cate_cnt: 0, use: 1}])
    state.appSearchFilter.appSearchTech = Object.freeze([{app_tech_id: -1, app_tech_uname: i18n.t('cmn.all'), app_tech_cnt: 0, use: 1}])
    state.appSearchFilter.appSearchChar = Object.freeze([{app_char_id: -1, app_char_uname: i18n.t('cmn.all'), app_char_cnt: 0, use: 1}])
    state.appSearchFilter.appSearchTag = Object.freeze([{app_tag_id: -1, app_tag_uname: i18n.t('cmn.all'), app_tag_cnt: 0, use: 1}])
    state.appSearchFilter.appSearchCountry = Object.freeze([{app_cntry_id: -1, app_cntry_uname: i18n.t('cmn.all'), app_cntry_cnt: 0, app_cntry_code: '', use: 1}])
    state.appSearchFilter.appSearchRisk = Object.freeze([{app_risk_id: -1, app_risk_uname: i18n.t('cmn.all'), app_risk_cnt: 0, use: 1}])
  },
  // 애플리케이션 객체 트리 목록 조회
  getAppObjectTreeDataList (state, data) {
    state.appObjectDataList = Object.freeze(data)
  },
  // 애플리케이션 목록 초기화
  resetAppObjectDataList (state) {
    state.appObjectDataList = []
  },
  // 애플리케이션 객체 초기화
  resetAppObjectData (state) {
    state.appData = initAppData()
  },
  // 애플리케이션 객체 저장
  saveAppObjectData (state, data) {
    const appObjectDataList = _.cloneDeep(state.appObjectDataList)
    const formData = _.assign(data, {
      // TAMS
      app_cate_uname: _.get(data.app_cate, 'app_cate_uname', ''),
      app_char_uname: _.map(data.app_char, 'app_char_uname').join(','),
      app_tag_uname: _.map(data.app_tag, 'app_tag_uname').join(','),
      app_tech_uname: _.map(data.app_tech, 'app_tech_uname').join(','),
      app_cntry_code: _.get(data, ['app_cntry', 'app_cntry_code'], ''),
      app_risk_id: _.get(data, ['app_risk', 'app_risk_id'])
    })
    appObjectDataList.unshift(formData)
    state.appObjectDataList = Object.freeze(appObjectDataList)
  },
  // 애플리케이션 객체 선택
  selectedAppObject (state, data) {
    state.selectedData = data
  },
  // 애플리케이션 객체 조회
  getAppObjectData (state, data) {
    // TAMS
    state.appData = {
      app_obj_name: data.app_obj_name,
      app_type: data.app_type,
      app_obj_desc: data.app_obj_desc,
      app_cate_id: data.app_cate.app_cate_id,
      app_risk_id: data.app_risk.app_risk_id,
      app_cntry_id: data.app_cntry.app_cntry_id,
      app_tech: _.map(data.app_tech, 'app_tech_id'),
      app_char: _.map(data.app_char, 'app_char_id'),
      app_tag: _.map(data.app_tag, 'app_tag_id'),
      app_obj_tcp_tm_out: data.app_obj_tcp_tm_out,
      app_obj_udp_tm_out: data.app_obj_udp_tm_out,
      app_signtr: data.app_signtr,
      cfg_dt: data.cfg_dt,
      admin_login_uname: data.admin_login_uname,
      app_obj_type: data.app_obj_type,
      app_obj_id: data.app_obj_id
    }
  },
  // 애플리케이션 객체 시스템 정의 객체 조회
  getAppViewObjectData (state, data) {
    state.appViewData = _.assign(data, {
      app_tech: _.map(data.app_tech, 'app_tech_id'),
      app_char: _.map(data.app_char, 'app_char_id'),
      app_tag: _.join(_.map(data.app_tag, 'app_tag_uname'), ', ')
    })
  },
  // 애플리케이션 객체 수정
  updateAppObjectData (state, data) {
    const formData = () => {
      return _.assign(data, {
        app_cate_uname: _.isString(_.get(data, ['app_cate'], void 0)) ? data.app_cate : _.get(data.app_cate, 'app_cate_uname', ''),
        app_char_uname: _.isString(_.get(data, ['app_char'], void 0)) ? data.app_char : _.map(data.app_char, 'app_char_uname').join(','),
        app_tag_uname: _.isString(_.get(data, ['app_tag'], void 0)) ? data.app_tag : _.map(data.app_tag, 'app_tag_uname').join(','),
        app_tech_uname: _.isString(_.get(data, ['app_tech'], void 0)) ? data.app_tech : _.map(data.app_tech, 'app_tech_uname').join(','),
        app_cntry_code: _.isString(_.get(data, ['app_cntry'], void 0)) ? data.app_cntry : _.get(data, ['app_cntry', 'app_cntry_code'], ''),
        app_risk_id: _.isString(_.get(data, ['app_risk'], void 0)) ? data.app_risk : _.get(data, ['app_risk', 'app_risk_id'])
      })
    }
    const reculsiveFindApp = (dataList, targetId, targetName, type) => {
      if (!_.isArray(dataList)) return []
      _.forEach(dataList, obj => {
        if (obj.app_obj_id === targetId && type === 'parent') {
          obj = formData()
          return false
        } else if (obj.app_obj_id === targetId) {
          obj = _.assign(obj, {app_obj_use_yn: data.app_obj_use_yn})
          return false
        }
        if (targetName.toLowerCase().indexOf(obj.app_obj_name.toLowerCase()) === 0 && _.isArray(obj.children)) {
          obj.children = reculsiveFindApp(obj.children, targetId, targetName)
          return false
        }
      })
      return dataList
    }
    const appObjectDataList = reculsiveFindApp(_.cloneDeep(state.appObjectDataList), data.app_obj_id, data.app_obj_name, 'parent')
    state.appObjectDataList = Object.freeze(appObjectDataList)
  },
  // 애플리케이션 객체 식별 전체 수정
  updateAllUseAppObjectData (state, data) {
    const appObjectDataList = _.map(state.appObjectDataList, (o) => {
      // TAMS
      if (o.app_obj_type === 3) {
        _.forEach(_.get(o, ['children'], []), (j) => {
          // TAMS
          if (j.app_obj_type === 3) {
            _.forEach(_.get(j, ['children'], []), (k) => {
              k.app_obj_use_yn = data
            })
          } else {
            j.app_obj_use_yn = data
          }
        })
      }
      return _.assign(o, {
        app_obj_use_yn: o.app_obj_type === 3 ? void 0 : data
      })
    })
    state.appObjectDataList = Object.freeze(appObjectDataList)
  },
  // 애플리케이션 객체 삭제
  deleteAppObjectData (state, data) {
    const appObjectDataList = _.cloneDeep(state.appObjectDataList)
    const itemIndex = _.findIndex(appObjectDataList, {app_obj_id: data})

    appObjectDataList.splice(itemIndex, 1)

    state.appObjectDataList = Object.freeze(appObjectDataList)
  },
  // 애플리케이션 객체 일괄 삭제
  deleteBatchAppObjectData (state, data) {
    const appObjectDataList = _.cloneDeep(state.appObjectDataList)
    _.forEach(data, (o) => {
      const itemIndex = _.findIndex(appObjectDataList, {app_obj_id: o.app_obj_id})
      appObjectDataList.splice(itemIndex, 1)
    })
    state.appObjectDataList = Object.freeze(appObjectDataList)
  },
  // 선택된 객체 초기화
  resetObjectSelectData (state) {
    state.selectedData = void 0
  },
  resetApplicationCopyData (state) {
    state.copyData = void 0
  },
  // 애플리케이션 객체 복사
  copyAppData (state, data) {
    state.copyData = {
      app_obj_name: data.app_obj_name,
      app_type: data.app_type,
      app_obj_desc: data.app_obj_desc,
      app_cate_id: data.app_cate.app_cate_id,
      app_risk_id: data.app_risk.app_risk_id,
      app_cntry_id: data.app_cntry.app_cntry_id,
      app_tech: _.map(data.app_tech, 'app_tech_id'),
      app_char: _.map(data.app_char, 'app_char_id'),
      app_tag: _.map(data.app_tag, 'app_tag_id'),
      app_obj_tcp_tm_out: data.app_obj_tcp_tm_out,
      app_obj_udp_tm_out: data.app_obj_udp_tm_out,
      app_signtr: data.app_signtr,
      cfg_dt: data.cfg_dt,
      admin_login_uname: data.admin_login_uname
    }
  },
  // 애플리케이션 객체 붙여넣기
  pasteAppData (state) {
    state.appData = _.cloneDeep(state.copyData)
  },
  // 애플리케이션 필터에 사용 적용
  setSearchFilter (state, {filters = {}}) {
    const dict = {
      app_cate: {field: 'appSearchCategory', id: 'app_cate_id'},
      app_char: {field: 'appSearchChar', id: 'app_char_id'},
      app_cntry: {field: 'appSearchCountry', id: 'app_cntry_id'},
      app_risk: {field: 'appSearchRisk', id: 'app_risk_id'},
      app_tag: {field: 'appSearchTag', id: 'app_tag_id'},
      app_tech: {field: 'appSearchTech', id: 'app_tech_id'}
    }
    const appSearchFilter = _.cloneDeep(state.appSearchFilter)
    for (let i = 0, l = Object.keys(dict).length; i < l; i++) {
      const key = Object.keys(dict)[i]
      if (!_.has(filters, key)) return
      let isAll = true
      const id = dict[key].id
      const field = dict[key].field
      _.forEach(filters[key], (o) => {
        const item = _.find(appSearchFilter[field], (k) => { return k[id] === o[id] })
        if (!item) return
        item.use = 1
        isAll = false
      })
      if (!isAll) {
        appSearchFilter[field][0].use = 0
      }
      appSearchFilter[field] = Object.freeze(appSearchFilter[field])
    }
    state.appSearchFilter = appSearchFilter
  },
  // 기본 애플리케이션 버전 정보 설정
  setDefaultAppVersion (state, version) {
    if (!version) return
    state.defaultAppVersion = version
  },
  setCountryCode (state, data) {
    const index = {}
    const countryArr = _.get(data, 'filter_app_cntry', [])
    _.forEach(countryArr, cntryInfo => {
      const code = _.get(cntryInfo, 'app_cntry_code', 'none') // TAMS (code -> app_cntry_code)
      const name = _.get(cntryInfo, 'app_cntry_uname', 'None') // TAMS (name -> app_cntry_uname)
      index[code] = name
    })
    state.countryCode = index
  }
}
export const actions = {
  // 애플리케이션 필터 조건 조회
  async getAppFilterData ({commit, state, rootState}, {filter, loadingShow = true, loadingHide = false, isNotSetAppFilter = false} = {}) {
    let filterData = {
      app_cate_id_list: [],
      app_tech_id_list: [],
      app_char_id_list: [],
      app_tag_id_list: [],
      app_cntry_id_list: [],
      app_risk_id_list: [],
      app_obj_filetype_yn: 0
    }
    if (filter) filterData = filter
    filterData = _.assign(filterData, {
      lang_type: rootState.common.locale.locale // ko, en
    })
    const res = await this.$axios.$post(`${objApiPrefix}/app/filter`, filterData, {
      loadingShow,
      loadingHide,
      successAlert: false
    })
    if (res.code === 'ok') {
      if (!filter) commit('resetAppSearchFilterData', res.result)
      if (!isNotSetAppFilter) commit('setAppFilterData', res.result)
      if (_.isEmpty(state.countryCode)) commit('setCountryCode', res.result)
      if (!filter) commit('getAppSearchFilterData', res.result)
      else commit('updateAppSearchFilterData', res.result)
    }
    return res
  },

  // 애플리케이션 객체 트리 목록 조회 (객체 설정 외 기능에서 사용)
  async getAppObjectTreeDataList ({commit, dispatch, state, rootState}, {target = void 0, loadingShow = false, filter, loadingHide = true} = {}) {
    const url = `${objApiPrefix}/app/tree/objects/rule`
    if (!filter) {
      filter = {
        app_cate_id_list: [],
        app_tech_id_list: [],
        app_char_id_list: [],
        app_tag_id_list: [],
        app_cntry_id_list: [],
        app_risk_id_list: [],
        app_obj_filetype_yn: 0
      }
    }
    const {code, result} = await this.$axios.$post(url, filter, { loadingShow, loadingHide, successAlert: false })
    if (code === 'ok') {
      if (target !== 'group') commit('getAppObjectTreeDataList', result)
      else commit('cm/objectSecProfile/object/objectSettings/groupObject/setAppObjDataList', result, {root: true})
    }
  },
  // 애플리케이션 객체 트리 목록 조회 (객체 설정에서 사용)
  async getAppObjectTreeDataListWithUsedFlag ({commit, dispatch, state, rootState}, {target = void 0, loadingShow = false, filter, loadingHide = true} = {}) {
    const url = `${objApiPrefix}/app/tree/objects`
    if (!filter) {
      filter = {
        app_cate_id_list: [],
        app_tech_id_list: [],
        app_char_id_list: [],
        app_tag_id_list: [],
        app_cntry_id_list: [],
        app_risk_id_list: [],
        app_obj_filetype_yn: 0
      }
    }
    filter = _.assign(filter, { lang_type: rootState.common.locale.locale }) // ko, en
    const {code, result} = await this.$axios.$post(url, filter, {
      loadingShow,
      loadingHide,
      successAlert: false
    })
    if (code === 'ok') {
      if (target !== 'group') commit('getAppObjectTreeDataList', result)
      else commit('cm/objectSecProfile/object/objectSettings/groupObject/setAppObjDataList', result, {root: true})
    }
  },
  // 국가 코드 정보 조회
  async getCountryCode ({commit, state}) {
    if (!_.isEmpty(state.countryCode)) return
    const {code, result} = await this.$axios.$post(`${objApiPrefix}/app/filter`)
    if (code === 'ok') commit('setCountryCode', result)
  },
  // 애플리케이션 객체 목록 조회
  async getAppObjectDataList ({commit, dispatch, state}, {target = void 0, loadingShow = true, loadingHide = true, filter} = {}) {
    const url = `${objApiPrefix}/app/list/objects`
    if (!filter) {
      filter = {
        app_cate_id_list: [],
        app_tech_id_list: [],
        app_char_id_list: [],
        app_tag_id_list: [],
        app_cntry_id_list: [],
        app_risk_id_list: [],
        app_obj_filetype_yn: 0
      }
    }
    const {code, result} = await this.$axios.$post(url, filter, { loadingShow, loadingHide, successAlert: false })
    if (code === 'ok') {
      if (target !== 'group') commit('getAppObjectTreeDataList', result)
      else commit('cm/objectSecProfile/object/objectSettings/groupObject/setAppObjDataList', result, {root: true})
    }
  },
  // 애플리케이션 객체 추가
  async saveAppObjectData ({commit, dispatch, state}, {loadingShow = true, loadingHide = true, successAlert = true} = {}) {
    const appData = state.appData
    const res = await this.$axios.$post(`${objApiPrefix}/app/objects`, appData, {loadingShow, loadingHide, successAlert})
    if (res.code === 'ok') {
      commit('saveAppObjectData', res.result)
      dispatch('common/common/setIsChanged', true, {root: true})
    }
    return res
  },
  // 애플리케이션 객체 수정
  async updateAppObjectData ({commit, state, dispatch}, {loadingShow = true, loadingHide = true, successAlert = true} = {}) {
    const objectId = state.selectedData.app_obj_id
    const data = state.appData
    const res = await this.$axios.$put(`${objApiPrefix}/app/objects/${objectId}`, data, { loadingShow, loadingHide, successAlert })
    if (res.code === 'ok') {
      commit('updateAppObjectData', res.result)
      dispatch('common/common/setIsChanged', true, {root: true})
    }
    return res
  },
  // 애플리케이션 객체 식별 수정
  async updateUseAppObjectData ({commit, state, dispatch}, {value, item, loadingShow = true, loadingHide = true} = {}) {
    const objectId = item.app_obj_id
    let code = void 0, result = void 0
    try {
      const res = await this.$axios.$get(`${objApiPrefix}/app/objects/${objectId}`, {loadingShow: false, successAlert: false})
      const params = {
        app_obj_id: res.result.app_obj_id,
        app_cate_id: res.result.app_cate.app_cate_id,
        app_char: _.map(res.result.app_char, 'app_char_id'),
        app_cntry_id: res.result.app_cntry.app_cntry_id,
        app_risk_id: res.result.app_risk_id,
        app_signtr: res.result.app_signtr,
        app_tag: _.map(res.result.app_tag, 'app_tag_id'),
        app_tech: _.map(res.result.app_tech, 'app_tech_id'),
        app_obj_desc: res.result.app_obj_desc,
        app_obj_name: res.result.app_obj_name,
        app_obj_tcp_tm_out: res.result.app_obj_tcp_tm_out,
        app_obj_udp_tm_out: res.result.app_obj_udp_tm_out,
        app_obj_use_yn: value
      }
      const response = await this.$axios.$put(`${objApiPrefix}/app/objects/${objectId}`, params, {loadingShow, loadingHide, successAlert: false})
      code = _.get(response, ['code'])
      result = _.get(response, ['result'])
    } catch (e) {
      item.app_obj_use_yn = (item.app_obj_use_yn === 1) ? 0 : 1
      commit('updateAppObjectData', item)
    }
    if (code === 'ok') {
      commit('updateAppObjectData', result)
      dispatch('common/common/setIsChanged', true, {root: true})
    }
  },
  // 애플리케이션 객체 식별 전체 수정
  async updateAllUseAppObjectData ({commit, state, dispatch}, {value, loadingShow = true, loadingHide = true} = {}) {
    const allAppObj = []
    _.forEach(state.appObjectDataList, o => {
      if (o.app_obj_type !== 3) return allAppObj.push(o)
      if (!o.children) return
      _.forEach(o.children, j => {
        if (j.app_obj_type !== 3) return allAppObj.push(j)
        if (!j.children) return
        _.forEach(j.children, k => { allAppObj.push(k) })
      })
    })
    const params = {
      items: _.filter(allAppObj, o => o.app_obj_type !== 3).map((o) => { // Tree 상위는 제외
        return {
          app_obj_id: o.app_obj_id,
          app_obj_name: o.app_obj_name,
          app_obj_use_yn: value
        }
      })
    }
    const {code, result} = await this.$axios.$put(`${objApiPrefix}/app/objects`, params, {loadingShow, loadingHide, successAlert: false})
    if (code === 'ok') {
      commit('updateAllUseAppObjectData', value)
      dispatch('common/common/setIsChanged', true, {root: true})
    } else if (code === 'pok' || code === 'nok') {
      const successList = _.filter(params.items, o => _.findIndex(result.errors, {app_obj_id: o.app_obj_id}) === -1)
      _.forEach(successList, (o) => {
        const item = _.find(allAppObj, k => k.app_obj_id === o.app_obj_id)
        if (!item) return
        const data = _.assign(item, o)
        commit('updateAppObjectData', data)
      })
      if (code === 'pok') dispatch('common/common/setIsChanged', true, {root: true})
      return result.errors
    }
  },
  // 애플리케이션 객체 조회
  async getAppObjectData ({commit, state}, {loadingShow = true, loadingHide = true} = {}) {
    const objectId = state.selectedData.app_obj_id
    const res = await this.$axios.$get(`${objApiPrefix}/app/objects/${objectId}`, {loadingShow, loadingHide})
    if (res.code === 'ok') {
      if (res.result.app_obj_type === 0) commit('getAppViewObjectData', res.result)
      else commit('getAppObjectData', res.result)
    }
    return res
  },

  // 애플리케이션 객체 조회 - 시스템 정의 객체 (로그 앱객체 정보 보기에서만 사용, 정책/객체 설정 서 제외)
  async getAppViewObjectData ({commit, state}, {loadingShow = true, loadingHide = true} = {}) {
    const objectId = state.selectedData.app_obj_id
    const res = await this.$axios.$get(`${objApiPrefix}/app/objects/${objectId}`, {loadingShow, loadingHide})
    if (res.code === 'ok') commit('getAppViewObjectData', res.result)
    return res
  },

  // 애플리케이션 객체 삭제 (단일, 다수 관계 없이 동일 API 사용)
  async deleteAppObjectData ({commit, dispatch, state}, {loadingShow = true, loadingHide = true} = {}) {
    const objectId = state.selectedData.app_obj_id
    if (isPreDefineWithApp(state.selectedData)) return {isPreDefine: true}
    let code = void 0
    let cause = void 0
    try {
      const response = await this.$axios.$delete(`${objApiPrefix}/app/objects/${objectId}`, {isReturnError: true, loadingShow, loadingHide})
      code = _.get(response, ['code'])
    } catch (e) {
      code = _.get(e, ['data', 'code'])
      cause = _.get(e, ['data', 'message'])
    }
    if (code === 'ok') {
      commit('deleteAppObjectData', objectId)
      dispatch('common/common/setIsChanged', true, {root: true})
      commit('resetObjectSelectData')
    } else if (Number(code) === 15010) {
      const selectedData = _.cloneDeep(state.selectedData)
      return {
        notDelete: [],
        forceDelete: [_.assign(selectedData, {cause: cause})]
      }
    } else {
      const selectedData = _.cloneDeep(state.selectedData)
      return {
        notDelete: [_.assign(selectedData, {cause: cause})],
        forceDelete: []
      }
    }
  },
  // 애플리케이션 객체 일괄 삭제
  async deleteBatchAppObjectData ({commit, dispatch, state}, {forceYn = 0, loadingShow = true, loadingHide = true, successAlert = true} = {}) {
    let appObjIdList = [], multiSelectedData = []
    const id = 'app_obj_id'
    const selectedData = _.cloneDeep(state.selectedData)
    if (_.get(selectedData, ['length'], 0) > 0) {
      appObjIdList = _.map(selectedData, id)
      multiSelectedData = selectedData
    } else {
      appObjIdList = [selectedData[id]]
      multiSelectedData = [selectedData]
    }
    const params = {
      app_obj_id_list: appObjIdList,
      force_yn: forceYn
    }
    // TAMS, 애플리케이션 그룹 객체일 경우 예외
    if (isPreDefineWithApp(state.selectedData)) return {isPreDefine: true}
    const res = await this.$axios.$put(`${objApiPrefix}/app/objects/multi`, params, {loadingShow, loadingHide, successAlert})
    if (res.code === 'ok') {
      res.result.can_not_delete = _.get(res.result, ['can_not_delete'], []).map(o => _.assign(o, _.find(multiSelectedData, [id, o[id]])))
      res.result.force_delete_pass = _.get(res.result, ['force_delete_pass'], []).map(o => _.assign(o, _.find(multiSelectedData, [id, o[id]])))
      dispatch('common/common/setIsChanged', true, {root: true})
      commit('resetObjectSelectData')
    }
    return res
  },
  async isValidSignatureOption ({state}, {loadingShow = true, loadingHide = false, mode} = {}) {
    const res = { code: 'ok', result: {} }
    try {
      let appId = null
      if (mode !== 'add') appId = state.appData.app_obj_id
      const params = { app_obj_id: appId, ...state.appSignatureData }
      const res = await this.$axios.$post(`${objApiPrefix}/app/sig/valid`, params, {
        loadingShow,
        loadingHide,
        successAlert: false,
        isNotShowErrorAlert: true
      })
      return res
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
      return res
    }
  },
  // 애플리케이션 앱 객체 default 버전의 정보
  async reqDefaultAppVersion ({state, commit}, {loadingShow = true, loadingHide = false} = {}) {
    const params = {
      device_contents_update_db_type: 2 // 컨텐츠 DB 종류(IPS 컨텐츠 DB: 1 애플리케이션 제어 DB: 2 웹 필터 DB: 3 안티 바이러스 DB: 4 블랙리스트 DB: 5 DLP DB: 6 APT 정책: 7 파일 유형 제어 DB: 8 SSL 예외 목록: 9 사설인증서 DB: 10 디바이스 정책 DB: 11)
    }
    const res = await this.$axios.$get(`${objApiPrefix}/app/version`, {params, loadingShow, loadingHide})
    if (res.code === 'ok') {
      const ver = _.get(res.result, ['contents_version'], '')
      commit('setDefaultAppVersion', ver)
    }
    return res
  },
  async reqCopyAppData ({state, commit}, {loadingShow = true, loadingHide = true} = {}) {
    const objectId = state.selectedData.app_obj_id
    const {code, result} = await this.$axios.$get(`${objApiPrefix}/app/objects/${objectId}`, {loadingShow, loadingHide})
    if (code === 'ok') {
      commit('copyAppData', result)
    }
  }
}
export const strict = false
